import { getTHERMSImageThumbnailUrl } from "../../Files/utils/get-therms-image-thumbnail-url.js";
import { useUser } from "../hooks/useUser.js";
import "react";
import { Avatar } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
//#region src/modules/Users/shared/UserAvatar.tsx
var UserAvatarFromId = ({ userId, ...avatarProps }) => {
	const { data, loading } = useUser({ userId }, { cacheStrategy: "cache-only" });
	if (!data?.user && loading) return /* @__PURE__ */ jsx(Avatar, { circular: true });
	if (!data?.user || !userId) return null;
	return /* @__PURE__ */ jsx(Avatar, {
		...avatarProps,
		url: getTHERMSImageThumbnailUrl(data?.user.avatarUrl),
		circular: true
	});
};
var UserAvatar = ({ user, userId, ...avatarProps }) => {
	if (user) return /* @__PURE__ */ jsx(Avatar, {
		...avatarProps,
		url: getTHERMSImageThumbnailUrl(user.avatarUrl),
		circular: true
	});
	if (userId) return /* @__PURE__ */ jsx(UserAvatarFromId, {
		...avatarProps,
		userId
	});
	return /* @__PURE__ */ jsx(Avatar, {
		...avatarProps,
		circular: true
	});
};
//#endregion
export { UserAvatar };

//# sourceMappingURL=UserAvatar.js.map